export const areas: Record<string, string> = {
	area_base_archives: "Arquivos da base",
	area_base_level: "Base nível $1",
	area_caves: "Cavernas nível $1",
	area_cursed_caves: "Cavernas Amaldicoadas $1",
	area_cursed_wasteland: "Deserto Amaldicoado $1",
	area_robot_base: "Base dos Robôs",
	area_sealed_passage: "Passagem Selada",
	area_tutorial_1: "Tutorial Nível 1",
	area_tutorial_2: "Tutorial Nível 2",
	area_tutorial_3: "Tutorial Nível 3",
	area_tutorial_4: "Tutorial Nível 4",
	area_wasteland: "Deserto",
	area_wasteland_level: "Deserto nível $1",
	area_branch_cave: "Caverna Alternativa",
	area_power_plant_level: "Usina nível $1",
	area_power_plant_underground: "Subsolo da usina $1",
};
